// import ElectricIcon from "../../../../../../../../../assets/svg/electric-icon";
// import { useMemo } from "react";
import InfoBtnIcon from "../../../../../../../../../assets/svg/info-btn-icon";
import Input from "../../../../../../../../../components/Input/Input";
import SubtractIcon from "../../../../../../../../../assets/svg/subtract-icon";
import AddIcon from "../../../../../../../../../assets/svg/add-icon";
// import CrossIcon from "../../../../../../../../../assets/svg/cross-icon";
// import CompletedIcon from "../../../../../../../../../assets/svg/completed-icon";
import { FormikProps } from "formik";
import { AgentDetailsValues } from "../../../../utils/types";
import { leadTypesConfig } from "./utils/constants";
// import { calculateMinMaxFromRanges } from "./utils/functions";
import { EditUserDetailsValues } from "../../../../../EditUserDrawer/utils/types";

interface LeadAssignmentsProps {
  formik: FormikProps<AgentDetailsValues> | FormikProps<EditUserDetailsValues>;
}

export const LeadAssignments = ({ formik }: LeadAssignmentsProps) => {
  const { velocity, daily_assignment_limit } = formik?.values || {};

  // const updateMinMaxScores = (ranges: string[]) => {
  //   const { min_score, max_score } = calculateMinMaxFromRanges(ranges);
  //   formik?.setFieldValue("min_score", min_score);
  //   formik?.setFieldValue("max_score", max_score);
  // };

  const handleDistributionRateChange = (value: number) => {
    if (value < 0) {
      formik?.setFieldError("velocity", "Distribution rate cannot be negative");
      return;
    }
    formik?.setFieldValue("velocity", Number(value));
  };

  const handleDailyLimitChange = (value: number) => {
    if (value < 0) {
      formik?.setFieldError(
        "daily_assignment_limit",
        "Daily assignment limit cannot be negative"
      );
      return;
    }
    formik?.setFieldValue("daily_assignment_limit", Number(value));
  };

  // const handleLeadScoreRangeToggle = (id: string) => {
  //   const currentRanges = selected_lead_ranges || [];
  //   const newRanges = currentRanges?.includes(id)
  //     ? currentRanges?.filter((rangeId) => rangeId !== id)
  //     : [...currentRanges, id];
  //   formik?.setFieldValue("selected_lead_ranges", newRanges);
  //   updateMinMaxScores(newRanges);
  // };

  const handleLeadTypeToggle = (id: string) => {
    const currentValue = formik?.values?.[id as keyof AgentDetailsValues];
    formik?.setFieldValue(id, !currentValue);
  };

  // const handleSelectAllLeadScoreRanges = () => {
  //   const allRanges = leadScoreRangesConfig?.map((range) => range?.id);
  //   formik?.setFieldValue("selected_lead_ranges", allRanges);
  //   updateMinMaxScores(allRanges);
  // };

  // const handleDeselectAllLeadScoreRanges = () => {
  //   formik?.setFieldValue("selected_lead_ranges", []);
  //   updateMinMaxScores([]);
  // };

  // const allLeadScoreRangesSelected = useMemo(() => {
  //   const allRanges = leadScoreRangesConfig?.map((range) => range?.id);
  //   const currentRanges = selected_lead_ranges || [];
  //   return allRanges?.length === currentRanges?.length;
  // }, [selected_lead_ranges]);

  // const shouldShowLeadRangeError =
  //   Boolean(formik?.touched?.selected_lead_ranges) &&
  //   (!Array.isArray(selected_lead_ranges) ||
  //     selected_lead_ranges?.length === 0);

  return (
    <div className="flex flex-col gap-y-9 mb-2.5">
      <div className="flex flex-col gap-y-[14px]">
        <div className="flex flex-col gap-y-[7px]">
          <div className="flex items-center gap-1">
            <div className="text-verba-field-label dark:text-verba-field-label-dk text-md">
              Lead distribution rate
            </div>
            <InfoBtnIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
          </div>
          <div className="relative w-[264px]">
            <Input
              type="number"
              value={velocity?.toString()}
              onChange={(e) =>
                handleDistributionRateChange(Number(e?.target?.value))
              }
              containerClassName="w-full"
              secondaryContainerClassName="border border-border-gray dark:border-border-gray-dk rounded-lg bg-pure-white dark:bg-pure-white-dk"
              inputClassName="no-number-arrows py-[9px] pl-2 pr-16 font-medium text-md text-heading-text dark:text-heading-text-dk"
              placeholder="Enter distribution rate"
              onBlur={formik?.handleBlur}
              error={formik?.touched?.velocity && !!formik?.errors?.velocity}
              errorMessage={formik?.errors?.velocity}
            />
            <div className="absolute flex items-center gap-2 right-2 top-2.5">
              <button
                className="cursor-pointer"
                onClick={() => handleDistributionRateChange(velocity - 1)}
              >
                <SubtractIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk" />
              </button>
              <div className="border-l border-border-gray dark:border-border-gray-dk h-2.5" />
              <button
                className="cursor-pointer"
                onClick={() => handleDistributionRateChange(velocity + 1)}
              >
                <AddIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk cursor-pointer" />
              </button>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-y-[7px]">
          <div className="flex items-center gap-1">
            <div className="text-verba-field-label dark:text-verba-field-label-dk text-md">
              Daily assignment limit
            </div>
            <InfoBtnIcon className="w-[18px] h-[18px] text-gray-placeholder dark:text-gray-placeholder-dk" />
          </div>
          <div className="relative w-[264px]">
            <Input
              type="number"
              value={daily_assignment_limit?.toString()}
              onChange={(e) => handleDailyLimitChange(Number(e?.target?.value))}
              containerClassName="w-full"
              secondaryContainerClassName="border border-border-gray dark:border-border-gray-dk rounded-lg bg-pure-white dark:bg-pure-white-dk"
              inputClassName="no-number-arrows py-[9px] pl-2 pr-32 font-medium text-md text-heading-text dark:text-heading-text-dk"
              placeholder="Enter daily assignment limit"
              onBlur={formik?.handleBlur}
              error={
                formik?.touched?.daily_assignment_limit &&
                !!formik?.errors?.daily_assignment_limit
              }
              errorMessage={formik?.errors?.daily_assignment_limit}
            />
            <div className="absolute flex items-center gap-3 right-2 top-2.5">
              <div className="text-xs text-gray-placeholder dark:text-gray-placeholder-dk">
                / in a day
              </div>
              <div className="flex items-center gap-2">
                <button
                  className="cursor-pointer"
                  onClick={() =>
                    handleDailyLimitChange(daily_assignment_limit - 1)
                  }
                >
                  <SubtractIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk" />
                </button>
                <div className="border-l border-border-gray dark:border-border-gray-dk h-2.5" />
                <button
                  className="cursor-pointer"
                  onClick={() =>
                    handleDailyLimitChange(daily_assignment_limit + 1)
                  }
                >
                  <AddIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk cursor-pointer" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* 
      <div className="flex flex-col">
        <div className="select-none flex items-center justify-between mb-3">
          <span className="text-md font-semibold text-verba-indigo dark:text-verba-indigo-dk uppercase">
            LEAD SCORE RANGE
          </span>
          <div className="w-max cursor-pointer">
            {allLeadScoreRangesSelected ? (
              <div
                className="flex items-center gap-1"
                onClick={handleDeselectAllLeadScoreRanges}
              >
                <CrossIcon className="w-[14px] h-[14px] text-verba-red-alert dark:text-verba-red-alert-dk" />
                <span className="text-sm text-verba-red-alert dark:text-verba-red-alert-dk font-medium">
                  Deselect all
                </span>
              </div>
            ) : (
              <div
                className="flex items-center gap-1"
                onClick={handleSelectAllLeadScoreRanges}
              >
                <CompletedIcon className="w-[14px] h-[14px] text-verba-blue dark:text-verba-blue-dk" />
                <span className="text-sm text-verba-blue dark:text-verba-blue-dk font-medium">
                  Select all
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col gap-y-1.5">
          {leadScoreRangesConfig?.map((range) => {
            const isSelected = (selected_lead_ranges || [])?.includes(
              range?.id
            );
            return (
              <div
                key={range?.id}
                className={`flex items-center justify-between p-3 rounded-lg cursor-pointer border ${
                  isSelected
                    ? "bg-card-highlight-2 dark:bg-card-highlight-2-dk border-selected-option-highlight dark:border-selected-option-highlight-dk"
                    : "border-border-gray dark:border-border-gray-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
                }`}
                onClick={() => handleLeadScoreRangeToggle(range?.id)}
              >
                <div className="flex items-center justify-between w-full">
                  <div className="flex items-center gap-2">
                    <ElectricIcon className={`w-5 h-5 ${range?.color}`} />
                    <div>
                      <div className="text-md font-medium text-heading-text dark:text-heading-text-dk">
                        {range?.range}
                      </div>
                      <div className="text-xs text-dark-gray dark:text-dark-gray-dk">
                        {range?.description}
                      </div>
                    </div>
                  </div>
                  <input
                    type="checkbox"
                    checked={isSelected}
                    className="w-3 h-3 rounded-sm cursor-pointer"
                  />
                </div>
              </div>
            );
          })}
          {shouldShowLeadRangeError && (
            <div className="text-xs text-verba-red-alert dark:text-verba-red-alert-dk">
              Select at least one lead score range
            </div>
          )}
        </div>
      </div> */}

      <div className="flex flex-col">
        <div className="flex items-center justify-between mb-3">
          <span className="text-md font-semibold text-verba-indigo dark:text-verba-indigo-dk uppercase">
            LEAD TYPE
          </span>
        </div>
        <div className="flex gap-x-1.5">
          {leadTypesConfig?.map((type) => {
            const isSelected = Boolean(
              formik?.values?.[type?.id as keyof AgentDetailsValues]
            );
            return (
              <div
                key={type.id}
                className={`flex items-center justify-between p-3 w-[167px] rounded-lg border cursor-pointer ${
                  isSelected
                    ? "bg-card-highlight-2 dark:bg-card-highlight-2-dk border-selected-option-highlight dark:border-selected-option-highlight-dk"
                    : "border-border-gray dark:border-border-gray-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
                }`}
                onClick={() => handleLeadTypeToggle(type?.id)}
              >
                <div className="flex items-center gap-2">
                  <type.icon className={`w-5 h-5 ${type?.color}`} />
                  <div className="text-md font-medium text-heading-text dark:text-heading-text-dk">
                    {type?.name}
                  </div>
                </div>
                <input
                  type="checkbox"
                  checked={isSelected}
                  className="w-3 h-3 rounded-sm cursor-pointer"
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
